import { makeStyles } from 'tss-react/mui'

export const useCollapsibleHelpStyles = makeStyles()(theme => ({
  personaCollapsibleRoot: {
    width: '100%',
    alignSelf: 'stretch',
  },
  personaCollapsibleHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(2),
    padding: 0,
    margin: 0,
    border: 'none',
    background: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    font: 'inherit',
    color: 'inherit',
  },
  personaCollapsibleBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    paddingTop: theme.spacing(2),
    width: '100%',
  },
  personaChevron: {
    flexShrink: 0,
    width: theme.spacing(2),
    height: theme.spacing(2),
    color: theme.palette.textField.main,
  },
}))
